import { Directive, TemplateRef, ViewContainerRef, OnDestroy, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';

@Directive({
  selector: '[plrAllErrors]'
})
export class AllErrorsDirective implements OnDestroy {
  destroyed$: Subject<boolean> = new Subject<boolean>();

  @Input("plrAllErrors")
  set plrAllErrors(formControl: FormControl) {
    if (formControl) {
      this.destroyed$.next(true);
      this.destroyed$.next(false);
      formControl.statusChanges
        .takeUntil(this.destroyed$)
        .subscribe(() => {
          if (formControl.valid) {
            this.viewContainer.clear();
          } else {
            this.viewContainer.clear();
            for (var errorKey in formControl.errors) {
              var error = formControl.errors[errorKey];
              if(Array.isArray(error)){
                error.forEach(innerError => {
                    this.addError(innerError);
                })
              } else {
                this.addError(error)
              }              
            }
          }
        });
    }
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef) {
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  private addError(error: any): void {   
    var errorMessage = error; 
    if(errorMessage.message){
      errorMessage = errorMessage.message;
    }
    if(errorMessage){
      this.viewContainer.createEmbeddedView(this.templateRef, { "\$implicit": { message: errorMessage, type: error.violationType } });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/workspace/directives/all-errors.directive.ts